<template>
  <div id="echartsId" style="height: 250px; width: 300px; margin: 0 auto"></div>
</template>

<script>
export default {
  methods: {
    chartint() {
      let myChart = this.$echarts.init(document.getElementById("echartsId"));
      var option;

      option = {
        tooltip: {
          trigger: "item",
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: "60%",
            data: [
              { value: 40, name: "南宁市" },
              { value: 98, name: "柳州市" },
              { value: 32, name: "桂林市" },
              { value: 140, name: "北海市" },
              { value: 28, name: "钦州市" },
              { value: 26, name: "防城港市" },
              { value: 22, name: "梧州市" },
              { value: 18, name: "百色市" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
  mounted() {
    this.chartint();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/BarChart.vue